import { makeStyles } from "tss-react/mui";
import { MiButton, MiSectionHeader } from "@miplatform/components";
import { BUTTON_VARIANTS } from "@miplatform/constants";
import { Box, Typography } from "@mui/material";

export function PricingMatrixHeader() {
  const { classes, theme } = useStyles();

  return (
    <>
      <Box className={classes.header}>
        <Typography variant="HD4" color={theme.palette.common.white}>
          Set Labor & Material Pricing
        </Typography>
      </Box>
      <MiSectionHeader
        subtitle={
          <Typography className={classes.subtitleText} variant="body2">
            Set up drop types and add pricing levels with percentage adjustments
            to quickly tailor pricing for different jobs. Click Compare Price
            Levels to see the percentage difference between two pricing levels.
          </Typography>
        }
        variant="text"
        rightAction={
          <MiButton
            title="Compare Price Levels"
            variant={BUTTON_VARIANTS.OUTLINED}
            disabled // TODO: JP enable later in compare story.
          />
        }
      />
    </>
  );
}

const useStyles = makeStyles()((theme) => ({
  header: {
    backgroundColor: theme.palette.primary.medium,
    padding: theme.spacing(0, 3),
    borderRadius: 4,
    minHeight: 42,
    display: "flex",
    alignItems: "center",
  },
  subtitleText: {
    marginRight: theme.spacing(2),
  },
}));
